import * as REDUX_TYPES from '../types'

export const INITIAL_STATE = {
  controlColumnOpacity: 0,
  currency: 'USD',
  showEthInCurrency: true, //When true display amounts in currency and tooltip in ETH
  showMintingDefaults: true,
}

/* These settings are persisted for every user, signed-in or not */
const settingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case REDUX_TYPES.SETTINGS.CONTROL_COLUMN_OPACITY:
      return {
        ...state,
        controlColumnOpacity: action.controlColumnOpacity,
      }

    case REDUX_TYPES.SETTINGS.CURRENCY:
      return {
        ...state,
        currency: action.currency,
      }

    case REDUX_TYPES.SETTINGS.SET:
      return { ...action.settings }
    default:
      return state
  }
}
export default settingsReducer
